import t from"./object-is-prototype-of.js";var e=t,n=TypeError,a=function(r,o){if(e(o,r))return r;throw n("Incorrect invocation")};export{a as default};
